import React, { useRef } from 'react';
import './ModalShell.css';
import { useAutoFocus } from '../../hooks/useAutoFocus';
import { useEscapeKey } from '../../hooks/useEscapeKey';

export interface ModalShellProps {
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
  ariaLabel: string;
  showCloseButton?: boolean;
  closeAriaLabel?: string;
  closeOnOverlayClick?: boolean;
}

const ModalShell: React.FC<ModalShellProps> = ({
  onClose,
  children,
  className = 'modal',
  ariaLabel,
  showCloseButton = true,
  closeAriaLabel = 'Close',
  closeOnOverlayClick = false,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);

  useEscapeKey(onClose);
  useAutoFocus(modalRef);

  return (
    <div className="modal-shell-overlay" onClick={closeOnOverlayClick ? onClose : undefined}>
      <div
        ref={modalRef}
        className={`modal-shell-dialog ${className}`}
        onClick={e => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={ariaLabel}
        tabIndex={-1}
      >
        {showCloseButton ? (
          <button type="button" className="modal-shell-close" onClick={onClose} aria-label={closeAriaLabel}>
            x
          </button>
        ) : null}
        {children}
      </div>
    </div>
  );
};

export default ModalShell;
